import * as React from "react";
import { Widget, mk_widget } from "widgets-for-react";

function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

type colorTokenProps = {
  name: string;
  hex: string;
  border?: boolean;
};

function printRem(pixels: number): string {
  return `${(pixels / 16).toFixed(2)}rem`;
}

const ColorToken = (props: colorTokenProps) => (
  <>
    <tr className="styleguide-table__row" aria-hidden="true">
      {/* <td className="styleguide-table__seperator" colSpan={3}></td> */}
    </tr>

    <tr className="styleguide-table__row">
      <td className="styleguide-table__cell styleguide--styled">
        <code className="styleguide-token__code">$color--{props.name}</code>
        <p className="styleguide-token__description"></p>
      </td>
      <td className="styleguide-table__cell">
        <div
          className={`styleguide-token__color ${
            props.border ? "styleguide-token__color--border " : " "
          }token-color--${props.name}`}
        ></div>
      </td>
      <td className="styleguide-table__cell styleguide--styled">
        <span className="styleguide-token__attribute">
          {capitalizeFirstLetter(props.name)}
        </span>
        <span className="styleguide-token__attribute">#{props.hex}</span>
      </td>
    </tr>
  </>
);

type iconTokenProps = {
  name: string;
};

const IconToken = (props: iconTokenProps) => (
  <>
    <tr className="styleguide-table__row">
      <td className="styleguide-table__cell styleguide--styled">
        <code className="styleguide-token__code">#icon--{props.name}</code>
        <p className="styleguide-token__description"></p>
      </td>
      <td className="styleguide-table__cell">
        <svg
          className="styleguide-icon"
          width="40px"
          height="40px"
        >
          <use xlinkHref={`#icon--${props.name}`} />
        </svg>
      </td>
    </tr>
  </>
);

type fontTokenProps = {
  name: string;
  mobile: number;
  desktop: number;
  lineheight: number;
};

const FontToken = (props: fontTokenProps) => (
  <>
    <tr className="styleguide-table__row">
      <td className="styleguide-table__cell styleguide--styled">
        <code className="styleguide-token__code">%typo--{props.name}</code>
        <p className="styleguide-token__description"></p>
      </td>
      <td className="styleguide-table__cell">
        <p className="text--styled text--s">
          Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam
          porta sem malesuada magna mollis euismod.
        </p>
      </td>
      <td className="styleguide-table__cell styleguide--styled">
        <span className="styleguide-token__attribute">
          Font-size: {props.mobile}px - {props.desktop}px / Line-Height: {props.lineheight}px
        </span>
      </td>
    </tr>
  </>
);

export const styleguideTokens: Widget<never> = mk_widget({
  run: _ => (
    <>
      <section
        id="tokens"
        className="styleguide-chapter styleguide-chapter--token"
      >
        <header className="styleguide--styled styleguide-chapter__header">
          <h2 className="styleguide__title styleguide-chapter__title">
            Design Tokens
          </h2>
          <p className="styleguide-chapter__intro">
            Design tokens are the visual design atoms of the design system —
            specifically, they are named entities that store visual design
            attributes. We use them in place of hard-coded values (such as hex
            values for color or pixel values for spacing) in order to maintain a
            scalable and consistent visual system for UI development.
          </p>
        </header>

        <div className="styleguide-chapter__content">
          <section
            id="tokens-colors"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Colors</h3>
              <p className="styleguide-section__intro">
                Generic colors that are uses in this project Please refer to the
                description of each token for their intended usage.
              </p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--example">
                      Example
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <ColorToken name="white" hex="FFFFFF" border={true} />
                  <ColorToken name="marine" hex="9CD1C2" />
                  <ColorToken name="blue-100" hex="F1F7F9" border={true} />
                  <ColorToken name="blue-200" hex="6CACC7" />
                  <ColorToken name="blue-300" hex="1693B2" />
                  <ColorToken name="blue-400" hex="135B80" />
                  <ColorToken name="blue-500" hex="00417E" />
                  <ColorToken name="grey-300" hex="F3F3F3" border={true} />
                  <ColorToken name="grey-400" hex="445466" />
                  <ColorToken name="grey-500" hex="303139" />
                  <ColorToken name="grey-600" hex="333333" />
                  <ColorToken name="orange-200" hex="FCF5EF" border={true} />
                  <ColorToken name="orange-300" hex="F18700" />
                  <ColorToken name="orange-400" hex="FF6D27" />
                  <ColorToken name="orange-500" hex="E96A46" />
                </tbody>
              </table>
            </div>
          </section>

          <section
            id="tokens-fonts"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Fonts</h3>
              <p className="styleguide-section__intro">In progress: we still need to have the font family.</p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--example">
                      Example
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        font--strawford
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell font--strawford">
                      <p>
                        Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam
                        porta sem malesuada magna mollis euismod.
                      </p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        font-family: 'Strawford', serif;
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          {/* tokens-styles */}
          <section
            id="tokens-styles"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Font Styles</h3>
              <p className="styleguide-section__intro"></p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--example">
                      Example
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $weight--regular
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell">
                      <p className="token-weight--400 text--styled">
                        Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam
                        porta sem malesuada magna mollis euismod.
                      </p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        Font-weight: 400
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $weight--medium
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell">
                      <p className="token-weight--500 text--styled">
                        Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam
                        porta sem malesuada magna mollis euismod.
                      </p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        Font-weight: 500
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $weight--bold
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell">
                      <p className="token-weight--700 text--styled">
                        Vulputate Commodo Sollicitudin Fringilla Nullam. Etiam
                        porta sem malesuada magna mollis euismod.
                      </p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        Font-weight: 700
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          {/* tokens-sizes */}
          <section
            id="tokens-sizes-heights"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">
                Font Sizes &amp; Line Heights
              </h3>
              <p className="styleguide-section__intro"></p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--example">
                      Example
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <FontToken name="s" mobile={18} desktop={18} lineheight={1.5}/>
                  <FontToken name="m" mobile={24} desktop={24} lineheight={1.3}/>
                  <FontToken name="l" mobile={48} desktop={48} lineheight={1.5}/>
                  <FontToken name="xl" mobile={72} desktop={72} lineheight={1.1111111111}/>
                 </tbody>
              </table>
            </div>
          </section>
          {/* tokens-icons */}
          <section
            id="tokens-icons"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Icons</h3>
              <p className="styleguide-section__intro">
                All icons are SVG symbols. Use the following code to use them:
              </p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide-table__heading--2-column styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--example">
                      Example
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <IconToken name="facebook"/>
                  <IconToken name="instagram"/>
                  <IconToken name="twitter"/>
                  <IconToken name="search"/>
                  <IconToken name="download"/>
                  <IconToken name="chevron"/>
                  <IconToken name="arrow"/>
                </tbody>
              </table>
            </div>
          </section>
          {/* tokens-widths */}
          <section
            id="tokens-widths"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Widths</h3>
              <p className="styleguide-section__intro"></p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide-table__heading--2-column styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">$width--s</code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        680 pixels
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">$width--m</code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        920 pixels
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">$width--l</code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        1440 pixels
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">$width--xl</code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        1880 pixels
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $width--s-gutter
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        760 pixels
                      </span>
                      <span className="styleguide-token__attribute">
                        Gutter: 2x40 pixels
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $width--m-gutter
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        1000 pixels
                      </span>
                      <span className="styleguide-token__attribute">
                        Gutter: 2x40 pixels
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $width--l-gutter
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        1520 pixels
                      </span>
                      <span className="styleguide-token__attribute">
                        Gutter: 2x40 pixels
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $width--xl-gutter
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        1960 pixels
                      </span>
                      <span className="styleguide-token__attribute">
                        Gutter: 2x40 pixels
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          { /* tokens-gutters-spacings */}
          <section
            id="tokens-spacings-gutters"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">
                Spacings &amp; Gutters
              </h3>
              <p className="styleguide-section__intro"></p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide-table__heading--2-column styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $spacing--s
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        20 pixels
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $spacing--m
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        40 pixels
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $gutter--xs
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        15 pixels
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $gutter--s
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        30 pixels
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $gutter--m
                      </code>
                      <p className="styleguide-token__description"></p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        40 pixels
                      </span>
                    </td>
                  </tr>

                  <tr className="styleguide-table__row" aria-hidden="true">
                    <td
                      className="styleguide-table__seperator"
                      colSpan={3}
                    ></td>
                  </tr>

                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">Grid base</code>
                      <p className="styleguide-token__description">We use the grid function to create all the other values</p>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        10 pixels
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          {/* tokens-transitions */}
          <section
            id="tokens-transitions"
            className="styleguide-section styleguide-section--token"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Transitions</h3>
              <p className="styleguide-section__intro"></p>
            </header>

            <div className="styleguide-section__content">
              <table className="styleguide-table">
                <thead>
                  <tr className="styleguide-table__heading styleguide-table__heading--2-column styleguide--styled">
                    <th className="styleguide-table__label styleguide-table__label--token">
                      Token
                    </th>
                    <th className="styleguide-table__label styleguide-table__label--attributes">
                      Attributes
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $transition--normal
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        0.3 seconds
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $transition--fast
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        0.2 seconds
                      </span>
                    </td>
                  </tr>
                  <tr className="styleguide-table__row">
                    <td className="styleguide-table__cell styleguide--styled">
                      <code className="styleguide-token__code">
                        $ease-out-back
                      </code>
                    </td>
                    <td className="styleguide-table__cell styleguide--styled">
                      <span className="styleguide-token__attribute">
                        cubic-bezier(0.175, 0.885, 0.32, 1.275)
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </section>
    </>
  )
});



// WEBPACK FOOTER //
// ./Client/styleguide/components/tokens.tsx